export function  isJSON  (object)  {
    var objectConstructor = ({}).constructor;
    if (object === null) {
        return false;
    }
    if (object === undefined) {
        return false;
    }
    if (object.constructor === objectConstructor) {
        return true;
    }
    return false;
    
}

export function generateID ()  {
    var result = 'MCFIT';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < 5; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

export function formatCountdown(timeRemaining) {
    const totalSeconds = Math.floor(timeRemaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (days > 0) {
        return `${days}g ${hours}h`;
    } else if (hours > 0) {
        return `${hours}h ${minutes}m`;
    } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
    } else {
        return `${seconds}s`;
    }
}